import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.5 1C4.253 1 0 5.253 0 10.5S4.253 20 9.5 20s9.5-4.253 9.5-9.5S14.747 1 9.5 1zm.583 13.984l-.083.012v1.519c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-1.531l-.083-.014c-1.159-.112-2.161-.521-2.917-1.311l.709-.967c.582.662 1.691 1.235 2.89 1.235 1.347 0 2.073-.626 2.073-1.486 0-.949-1.072-1.2-2.254-1.486-1.492-.34-3.182-.734-3.182-2.524 0-1.209.963-2.25 2.68-2.447l.083-.011V4.484c0-.276.224-.5.5-.5s.5.224.5.5v1.5l.083.013c1.182.125 2.07.597 2.681 1.199l-.638.931c-.526-.627-1.49-1.092-2.618-1.092-1.199 0-1.945.591-1.945 1.361 0 .823 1.001 1.056 2.145 1.325 1.528.34 3.291.77 3.291 2.686 0 1.328-1.003 2.404-2.917 2.578z',
  ],
  height: 20,
  width: 20,
});
